import { trackOpenNoLinksPopup } from './tracking';
import { IWsErrorEvent } from './types';
import { GuardError } from '../../errors/GuardError';
import { currentChatOpponentIdSelector } from '../../selectors';
import { checkUsersSession } from '../../services/checkUsersSession';
import { showAlert } from '../../slices/alertSlice';
import { EAlert } from '../../types/alert';
import { ERequestApiStatus, EWsClientEventType } from '../../types/appState';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { TThunkAction } from '../../types/redux/thunk';
import { ETelemetryEvents } from '../../types/telemetry';
import { EWsCodeError, EWsErrorMessage } from '../../types/wsErrorMessage';
import { createOutcomingMessage } from '../../utils/messageUtils';
import { setDeleteMessage, setSendMessageFailed } from '../sendMessage';

export const setWsError =
  (event: IWsErrorEvent): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { telemetry, logger, custom: { messagesMap, socket } }) => {
    if (!socket) {
      return;
    }

    const { clientEvents } = socket;

    const state = getState();

    const { uid, error } = event;
    const clientEvent = clientEvents.get(uid);
    const opponentId = currentChatOpponentIdSelector(state);

    if (!clientEvent) {
      return;
    }

    clientEvents.set(uid, { ...clientEvent, status: ERequestApiStatus.Failed });

    if (error.message === EWsErrorMessage.SessionExpired || error.message === EWsErrorMessage.InvalidSession) {
      telemetry.increment(ETelemetryEvents.ChatWsSessionExpire);

      const exception = new GuardError({
        domain: EExceptionDomain.Ws,
        message: 'Пришла ошибка при отправке сообщения по ws: сессия истекла',
      });

      logger.warning(exception);

      await dispatch(checkUsersSession());
    }

    const messageItem = messagesMap.get(uid);

    if (clientEvent.type !== EWsClientEventType.Message || !messageItem) {
      return;
    }

    const {
      message: {
        message: { message: text, userId },
        chatId,
      },
    } = messageItem;

    if (error.message === EWsErrorMessage.ValidationError && error.errors.length) {
      const isLinkError = error.errors.some(
        (error: { code: string }) => error.code === EWsCodeError.MessageHasLinkToAnotherService,
      );
      if (isLinkError) {
        telemetry.increment(ETelemetryEvents.ChatWsMessageSendFail);
        dispatch(setDeleteMessage({ chatId, messageId: uid, messagesMap }));
        clientEvents.delete(uid);
        dispatch(showAlert({ type: EAlert.MessageHasLinkToAnotherService, message: text, chatId }));
        trackOpenNoLinksPopup(opponentId);

        return;
      }
    }

    const message = createOutcomingMessage({ text, chatId, userId });
    dispatch(setSendMessageFailed({ message, messageId: uid, messagesMap }));
  };
